'use client'; // Error components must be Client Components
import React from 'react';
import { useEffect } from 'react';

import './(frontend)/globals.css';

import { Button } from '@/components/ui/button';
import { H2, P } from '@/components/ui/typography';
import { cn } from '@/lib/shared/ui';
import fonts from '@/lib/backend/layout/fonts';
import { Message } from '@/components/ui/message';

import useHoneybadger from '@/lib/frontend/hooks/useHoneybadger';
import { ContentWrapper } from '@/components/frontend/ui/content-wrapper';

/**
 * global-error.[js|tsx]: https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-errors-in-layouts
 */
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const { notify } = useHoneybadger();
  useEffect(() => {
    notify(error);
  }, [error]);

  return (
    <html
      data-theme="dark"
      className={cn(
        fonts.apercuMono.variable,
        fonts.apercuNormal.variable,
        fonts.apercuBold.variable,
        fonts.apercuItalic.variable,
      )}
    >
      <body className="flex items-center justify-center text-center font-sans gap-8">
        <ContentWrapper className="flex flex-col gap-5">
          <div className="flex flex-col gap-5">
            <H2>We're sorry!</H2>
            <div className="text-center flex flex-col gap-1">
              <P>Something went wrong with the site. We've been notified of the issue.</P>
              <P>You can try refreshing the page or clicking the button below.</P>
            </div>
            <Message variant="negative">{error.message}</Message>
          </div>
          <Button
            variant="outline"
            onClick={
              // Attempt to recover by trying to re-render the segment
              () => reset()
            }
          >
            Try again
          </Button>
        </ContentWrapper>
      </body>
    </html>
  );
}
